import BaseButton, { ButtonProps as BaseButtonProps } from 'carbon-react/lib/components/button/__next__';

export interface ButtonProps extends BaseButtonProps {
  tabIndex?: number;
}

const Button = ({ ref, ...props }: ButtonProps & { ref?: React.Ref<React.ComponentRef<typeof BaseButton>> }) => {
  return <BaseButton ref={ref} {...props} />;
};

export default Button;
